export default "__VITE_ASSET__DGnzOD2w__"